<template>
  <VueMarkdown :source="markdownText"/>
  <div style="text-align: center; margin-top: 40px">© TitleTool by MoovIT GmbH 2022</div>
</template>

<script src="./Changelog.ts"></script>
